export default __webpack_public_path__ + "static/3-4e4dc4031d86b2987d7204571b91ef43.png";